import React, { useState } from "react";
// import IntelliDash_Logo from "../../images/intellidash_logo.svg";
import {
  AppBar,
  Box,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Avatar,
  Stack,
  ListItemIcon,
  LogoutIcon,
  TroubleshootIcon,
  TuneIcon
} from "../../styles/MaterialUI";
import cookie from "react-cookies";
import { ZOHO_HELP_CENTER_LOGOUT } from "../../constants/apiConstants";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { removeUserToken } from "../Redux/Features/userTokenSlice";
import { openTroubleshoot } from "../Redux/Features/reloadMetricsSlice";

const Header = ({ portalLink }) => {
  const dispatch = useDispatch();
  const { userName, logoutURL, isInternalUser } = useSelector((state) => state.userLogin);
  const { userToken } = useSelector((state) => state.userToken);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const handleCloseUserMenu = () => setAnchorElUser(null);
  const headers = { Authorization: `Bearer ${userToken}` };

  const handleLogout = async () => {
    cookie.remove("JWTToken");
    dispatch(removeUserToken());
    try {
      localStorage.setItem('is_session_active', false);
      const response = await axios.post(`${logoutURL}`, { type: "mannual" }, { headers });

      if (response.status === 200) {
        window.open(response.data, "_self");
        let zohoTabName = localStorage.getItem('zohoHelpObject')
        if (zohoTabName) {
          logoutZohoDesk(zohoTabName);
        }
      } else {
        window.open("https://intellidash.net/", "_self");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  }

  const logoutZohoDesk = (zohoTabName) => {
    window.open(ZOHO_HELP_CENTER_LOGOUT.LOGOUT_URL, zohoTabName);
    localStorage.removeItem("zohoHelpObject");
    return false;
  }

  const handleHelpCenter = () => {
    const tabName = localStorage.getItem('zohoHelpObject');
    const newWindow = window.open("https://support.intellidash.net/portal/en/kb/articles/aristocast-basics", "intelliZohoHelpDesk");
    newWindow.focus();

    if (!tabName) {
      localStorage.setItem('zohoHelpObject', 'intelliZohoHelpDesk');
    }
  }

  const handleOpenTroubleshoot = () => {
    dispatch(openTroubleshoot());
    handleCloseUserMenu();
  }
  const handleClick = () => {
    const { url1, url2 } = portalLink || {};

    if (!url1) return;

    // Case 1: both URLs exist
    if (url1 && url2) {
      const win = window.open(url1, "_blank");

      if (!win) return;

      setTimeout(() => {
        win.location.href = url2;
      }, 2000);

      return;
    }

    // Case 2: only url1 exists
    window.open(url1, "_blank");
  };

  return (
    <Box>
      <AppBar position="fixed" sx={{ backgroundColor: "#fff", boxShadow: "-moz-initial" }}>
        <Toolbar variant="dense">
          <Grid container item xs={6} sx={{ marginLeft: "-15px" }}>
            <img src="AristoCast_logo_v2.png" alt="AristoCast Logo" style={{ width: "133px", marginTop: 2 }} />
          </Grid>
          <Grid container item xs={12} justifyContent="flex-end" alignItems="center">
            {/* NEW CONDITIONAL LINK */}
            {portalLink?.visible && (
              <span
                title="IntelliDash"
                onClick={handleClick}
                style={{
                  cursor: "pointer",
                  color: "#1976d2",
                  textDecoration: "underline",
                  fontSize: "14px",
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                  marginRight: "2rem"
                }}
              >
                {portalLink.text}
              </span>
            )}

            <Button variant="contained" size="small" onClick={handleHelpCenter} title="AristoCAST"
              sx={{ textTransform: "none", backgroundColor: "#003366", "&:hover": { backgroundColor: "#d32f2f" }, marginRight: "2rem", }}>
              Help Center
            </Button>
            <Tooltip title="User profile">
              <IconButton onClick={(e) => setAnchorElUser(e.currentTarget)} sx={{ p: 0, fontSize: "0.9rem" }}>
                <Stack display="flex" justifyContent="center" alignItems="center">
                  <Avatar sx={{ backgroundColor: "#ff8000", width: 24, height: 24 }}>
                    {/* <AccountCircleIcon sx={{ fontSize: "2rem" }} /> */}
                  </Avatar>
                  {userName}
                </Stack>
              </IconButton>
            </Tooltip>
            <Menu sx={{ mt: "25px" }} id="menu-appbar" anchorEl={anchorElUser} anchorOrigin={{ vertical: "top", horizontal: "right" }}
              keepMounted transformOrigin={{ vertical: "top", horizontal: "right" }} open={Boolean(anchorElUser)} onClose={handleCloseUserMenu}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible', filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))', mt: 1.5,
                  '& .MuiAvatar-root': { width: 32, height: 32, ml: -0.5, mr: 1 },
                  '&::before': {
                    content: '""', display: 'block', position: 'absolute', top: 0, right: 14, width: 10, height: 10, bgcolor: 'background.paper', transform: 'translateY(-50%) rotate(45deg)', zIndex: 0
                  },
                },
              }}
            >
              {isInternalUser === 1 &&
                <MenuItem onClick={handleOpenTroubleshoot}>
                  <ListItemIcon><TroubleshootIcon fontSize="small" /></ListItemIcon>
                  Troubleshooting
                </MenuItem>
              }
              <MenuItem onClick={handleLogout}>
                <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </Grid>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
